import { render, staticRenderFns } from "./assemblyUpload.vue?vue&type=template&id=63991f02&"
import script from "./assemblyUpload.vue?vue&type=script&lang=js&"
export * from "./assemblyUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports